import { useCallback, useState } from "react";

import { deleteMemberProjectAccess } from "Api/organizations/member/projectAccess/deleteMemberProjectAccess.request";
import { useNotification } from "Containers/Notifications";
import { isJson } from "Libs/utils";

export const useDeleteMemberProject = (userId: string) => {
  const notify = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<unknown>();

  const action = useCallback(
    async (projectId: string, showNotifications?: boolean) => {
      setIsLoading(true);
      try {
        await deleteMemberProjectAccess(userId, projectId);
        setIsLoading(false);
        if (showNotifications) {
          notify.success("Project access removed");
        }
      } catch (error) {
        setError(error);
        if (
          showNotifications &&
          error &&
          typeof error === "string" &&
          isJson(error)
        ) {
          const jsonError = JSON.parse(error);
          if (jsonError.title && jsonError.detail)
            notify.error(jsonError.title, jsonError.detail);
        }
      }
    },
    [userId, notify]
  );

  return {
    isLoading,
    action,
    error
  };
};
